import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { Switch } from "@/components/ui/switch"

export default function AppearanceSettingsTab() {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle className="text-primary">Branding</CardTitle>
          <CardDescription>Customize your site's logo and primary colors.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div>
            <Label htmlFor="logoUpload">Site Logo</Label>
            <Input id="logoUpload" type="file" className="mt-1" />
            <p className="text-xs text-gray-500 mt-1">Upload a new logo (PNG, JPG, SVG)</p>
          </div>
          <div>
            <Label htmlFor="primaryColor">Primary Color</Label>
            <Input id="primaryColor" type="color" defaultValue="#112614" className="mt-1 h-10 w-24" />
          </div>
          <div>
            <Label htmlFor="secondaryColor">Secondary Color</Label>
            <Input id="secondaryColor" type="color" defaultValue="#C1A87B" className="mt-1 h-10 w-24" />
          </div>
          <Button className="bg-primary hover:bg-primary/90 text-white">Save Branding</Button>
        </CardContent>
      </Card>
      <Card className="mt-8">
        <CardHeader>
          <CardTitle className="text-primary">Theme Settings</CardTitle>
          <CardDescription>Adjust the overall visual theme of the dashboard.</CardDescription>
        </CardHeader>
        <CardContent className="flex items-center justify-between">
          <div>
            <p className="font-medium text-primary">Enable Dark Mode</p>
            <p className="text-sm text-gray-600">Toggle between light and dark themes for the admin panel.</p>
          </div>
          <Switch />
        </CardContent>
      </Card>
    </>
  )
}
